import { isEmpty } from 'lodash-es'

// Constants
import { STORAGE_DATA } from '@/constants/storageData'

const setBuyNowCacheData = ({ productInfo, filteredItems, productAmount, roomId, referralFrom, referralId }: any) => {
  const cacheData = {
    merchantId: productInfo?.merchantId,
    skuId: filteredItems[0]?.skuId,
    quantity: productAmount,
    roomId,
    referralFrom,
    referralId,
  }

  if (!isEmpty(window)) {
    window.localStorage.setItem(STORAGE_DATA.FAST_CHECKOUT_CACHE_DATA, JSON.stringify(cacheData))
  }
}

export default setBuyNowCacheData
